/**
 * Creation gates — widget kinds the builder can render and publish but does
 * not yet let anyone ADD, because an editor that predates them would drop
 * them on publish. One constant, read by the Add menu and by the authoring
 * tools (MCP) alike. See docs/plans/2026-10-04-ds-widgets-add-menu.md,
 * "Release and rollback": switched on at R3, after the server refuses
 * editors below capability 2.
 */
export const ICON_INLINE_CREATION = true;

/** Kinds held back while their gate is off. */
export const GATED_WIDGET_KINDS: ReadonlySet<string> = ICON_INLINE_CREATION
  ? new Set()
  : new Set(["icon", "inline-grid"]);
